import type { TaskTypeViewPlacement } from '@erp/shared-types';

export type ScalarPlacement = Extract<
  TaskTypeViewPlacement,
  { component: 'field' | 'match' }
>;

type PlacementGroup =
  | { kind: 'scalars'; placements: ScalarPlacement[] }
  | { kind: 'block'; placement: TaskTypeViewPlacement };

function isScalarPlacement(
  placement: TaskTypeViewPlacement,
): placement is ScalarPlacement {
  return placement.component === 'field' || placement.component === 'match';
}

/**
 * Consecutive field and match placements share one label/value grid, so a
 * header reads as a compact form instead of a stack of full-width inputs.
 * Tables and viewers stay full width in their own block.
 */
export function groupPlacements(
  placements: readonly TaskTypeViewPlacement[],
): PlacementGroup[] {
  const groups: PlacementGroup[] = [];
  for (const placement of placements) {
    const last = groups[groups.length - 1];
    if (isScalarPlacement(placement)) {
      if (last?.kind === 'scalars') last.placements.push(placement);
      else groups.push({ kind: 'scalars', placements: [placement] });
      continue;
    }
    groups.push({ kind: 'block', placement });
  }
  return groups;
}
